import React from "react";
import { TCText } from "../TCText/TCText";
import { Colors } from "../../utils/colors";
import { PLAYER_PLACEHOLDER_WIDTH } from "../../utils/data";
import cross from "../../assets/cross.png";

interface SelectedPlayerCardProps {
  imageUrl?: string;
  name: string;
  rating?: string;
  onRemoveIconClick?: () => void;
  style?: React.CSSProperties;
}

export const SelectedPlayerCard: React.FC<SelectedPlayerCardProps> = ({
  imageUrl,
  name,
  rating,
  onRemoveIconClick,
  style,
}) => {
  const getInitials = (name: string) => {
    return name
      .split(" ")
      .map((word) => word[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };
  return (
    <div style={{ ...styles.container, ...style }} >
      {onRemoveIconClick && (
        <img
          src={cross}
          alt=""
          onClick={onRemoveIconClick}
          style={{ height: 10, width: 9, position: "absolute", right: 8 }}
        />
      )}
      <div
        style={{
          ...styles.avatarContainer,
          backgroundColor: imageUrl ? "transparent" : "black",
        }}>
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={name}
            style={styles.avatar}
            onError={(e) => {
              e.currentTarget.style.display = "none";
              e.currentTarget.parentElement!.dataset.initials =
                getInitials(name);
            }}
          />
        ) : (
          <TCText style={styles.initials} value={getInitials(name)} />
        )}
      </div>
      {rating && (
        <div
          style={{
            width: 35,
            height: 19,
            backgroundColor: Colors.gold,
            borderRadius: 100,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: -30,
          }}>
          <TCText
            style={{ fontWeight: 600, fontSize: 10, color: "white" }}
            value={rating}
          />
        </div>
      )}
      <TCText
        value={name}
        style={{
          ...styles.name,
          maxWidth: PLAYER_PLACEHOLDER_WIDTH - 20, // Account for padding
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      />
    </div>
  );
};

const styles = {
  container: {
    position: "relative" as const,
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    backgroundColor: Colors.background,
    borderRadius: 12,
    paddingTop: 7,
    paddingBottom: 10,
    paddingLeft: 8,
    paddingRight: 8,
    width: PLAYER_PLACEHOLDER_WIDTH,
  },
  removeIcon: {
    position: "absolute" as const,
    top: 4,
    right: 4,
    cursor: "pointer",
  },
  avatarContainer: {
    width: 42,
    height: 42,
    borderRadius: 21,
    overflow: "hidden",
    backgroundColor: "black",
    marginBottom: 4,
    marginTop: 10,
  },
  avatar: {
    width: "100%",
    height: "100%",
    objectFit: "cover" as const,
  },
  initials: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 16,
    fontWeight: 600,
    color: "white",
  },
  name: {
    fontSize: 10,
    color: Colors.green,
    textAlign: "center" as const,
    fontWeight: 500,
  },
};
